/* tslint:disable */

import {Injectable} from '@angular/core';
import {MouseStatus, SelectedPosition, TwoDView, TwoDViewVisualizationOptions, Zoom} from "../twoDViewModels";
import {TwoDService} from "../two-d.service";
import {LayoutService} from "../../../layout/layout.service";
import {BehaviorSubject} from "rxjs";
import {ShapeROIsService} from "../../../ROIs/shape-rois.service";
import * as THREE from 'three';
import {RegionsService} from "../../../regions/regions.service";
import {MarkersService} from "../../../markers/markers.service";
import {AtlasSharedService} from "../../../atlas-shared.service";
import {RectangularROI} from "../../../ROIs/ShapeROIsModel";
import {fas} from "@fortawesome/free-solid-svg-icons";

declare function drawString(text, position, color, font, canvas): any;

@Injectable({
    providedIn: 'root'
})
export class LayoutEventsService {
    subjectOnCanvasClick = new BehaviorSubject(false);

    // isPlayingVideo = false;
    videoPlayControls = {
        next: false,
        previous: false
    };
    intervalId: any;

    startPosRectangularROI = {x: 0, y: 0, z: 0};

    rangeValue = 0;

    constructor(public twoDService: TwoDService,
                private shapeROIsService: ShapeROIsService,
                private markersService: MarkersService,
                private regionsService: RegionsService,
                private layoutService: LayoutService,
                private atlasSharedService: AtlasSharedService) {
    }

    updateMouseStatus(mouseEvent, isMouseDown) {
        // new THREE.Vector2(mouseEvent.offsetX, mouseEvent.offsetY) means  the position on the Canvas
        // new THREE.Vector2(mouseEvent.clientX, mouseEvent.clientY) means  the position on the Screen
        MouseStatus.update(
            new THREE.Vector2(mouseEvent.offsetX, mouseEvent.offsetY),
            new THREE.Vector2(mouseEvent.clientX, mouseEvent.clientY),
            mouseEvent.target, isMouseDown);
    }

    updateSelectedPositionFromMousePosition(view, imageToCanvasRatio) {
        if (this.twoDService.activeView === null || this.twoDService.activeView.hasLabels) {
            SelectedPosition.set(
                view.convertCanvasCoordinatesIntoImageCoordinates(MouseStatus.positionOnCanvas,
                    imageToCanvasRatio));
            this.twoDService.updateScene();
        }
    }

    onMouseDown(event, imageToCanvasRatio, view) {
        if (event == null) {
            this.subjectOnCanvasClick.next(true);
            return 0;
        }
        this.updateMouseStatus(event, true);
        this.updateSelectedPositionFromMousePosition(view, imageToCanvasRatio);

        // In the case of an orthogonal view, which can be either Dorsal, Sagittal, or Coronal, this line of code enables the real-time updating of the orthogonal view canvases when the arrow keys are pressed. This functionality is necessary because, in the orthogonal view layout, there the activeView is null.
        this.twoDService.activeView = view;

        if (this.shapeROIsService.isROIsDrawingMode) {
            this.shapeROIsService.activeROI2DData.startPos = MouseStatus.positionOnScreen;
            if (!this.shapeROIsService.activeROI) {
                this.shapeROIsService.createNewROI(SelectedPosition.coordinates, null, false);
            } else {
                // SelectedPosition.coordinate is the real coordinate in the TIF file
                this.shapeROIsService.updateActiveROIFrom2D(SelectedPosition.coordinates);
            }
        } else if (this.shapeROIsService.isRectangularROIsDrawingMode) {
            // TwoDViewVisualizationOptions.labelsOptions.show = false;
            // this.twoDService.updateScene();
            //
            // this.shapeROIsService.activeRectangularROIData.setStartPos(SelectedPosition.coordinates.x, SelectedPosition.coordinates.y);
            //
            // if (!this.shapeROIsService.activeRectangularROI) {
            // this.shapeROIsService.createNewRectangularROI(this.shapeROIsService.activeRectangularROIData.startPos, "0xff0000", false);
            // } else {
            //     this.shapeROIsService.activeRectangularROIData.setStartPos(this.shapeROIsService.activeRectangularROIData["start"].x, this.shapeROIsService.activeRectangularROIData["start"].y);
            //     this.shapeROIsService.activeRectangularROI.dimensions = {
            //         width: 1,
            //         height: 1
            //     };
            // }
        }

        // Focus the twoDLayout Container to allow the canvases to be updated with the arrow keys.
        this.subjectOnCanvasClick.next(true);
    }


    onMouseMove(event, imageToCanvasRatio, view) {
        this.updateMouseStatus(event, null);

        // Left mouse bottom is clicked
        if (MouseStatus.isDown) {

            if (this.shapeROIsService.isROIsDrawingMode) {
                this.shapeROIsService.activeROI2DData.endPos = MouseStatus.positionOnScreen;
                this.shapeROIsService.activeROI2DData.radius = this.shapeROIsService.activeROI2DData.endPos.distanceTo(this.shapeROIsService.activeROI2DData.startPos);
                this.shapeROIsService.updateActiveROIRadiusFrom2D();
            } else if (this.shapeROIsService.isRectangularROIsDrawingMode) {
                // this.shapeROIsService.activeRectangularROIData.setEndPos(MouseStatus.positionOnScreen.x, MouseStatus.positionOnScreen.y);
                // this.shapeROIsService.activeRectangularROI.dimensions = {
                //     width: Math.abs(this.shapeROIsService.activeRectangularROIData.startPos.x - this.shapeROIsService.activeRectangularROIData.endPos.x),
                //     height: Math.abs(this.shapeROIsService.activeRectangularROIData.startPos.y - this.shapeROIsService.activeRectangularROIData.endPos.y)
                // };
                // this.shapeROIsService.updateActiveRectangularROIStartingPointFrom2D();

            } else {
                this.updateSelectedPositionFromMousePosition(view, imageToCanvasRatio);
            }


        }
        Zoom.update(null);
    }

    onMouseUp(event, imageToCanvasRatio, view) {
        this.updateMouseStatus(event, false);

        if (this.shapeROIsService.isROIsDrawingMode) {
            this.shapeROIsService.activeROI2DData.startPos = null;
            this.shapeROIsService.activeROI2DData.endPos = null;
        } else {
            this.updateSelectedPositionFromMousePosition(view, imageToCanvasRatio);

            if (this.atlasSharedService.panelMovementOptions.isGetRegionsOfPosition) {
                this.regionsService.getRegionsOfPosition(SelectedPosition.coordinates);
            }
        }


        TwoDViewVisualizationOptions.labelsOptions.show = true;
        this.twoDService.updateScene();

    }

    onMouseWheel(event, imageToCanvasRatio, view) {

        let scrollDistance = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

        SelectedPosition.coordinates[view.axis] += scrollDistance;

        if (SelectedPosition.coordinates[view.axis] < 0) {
            SelectedPosition.coordinates[view.axis] = 0;
        } else if (SelectedPosition.coordinates[view.axis] > (view.imageInfo.size.layers - 1)) {
            SelectedPosition.coordinates[view.axis] = (view.imageInfo.size.layers - 1);
        }
        this.twoDService.updateScene();

        Zoom.update(null);

    }

    onRangeInput(axis, value) {
        SelectedPosition.updateCoordinate(axis, value);
        this.twoDService.updateScene();
    }

    onRangeMouseUp(axis, value) {
        setTimeout(() => {
            this.onRangeInput(axis, value);
        }, 500);
    }

    onRangeStepButtonClick(view: TwoDView, shift) {
        this.drawNextFrame(view, shift);
    }

    drawNextFrame(view: TwoDView, shift) {
        SelectedPosition.adjustCoordinate(view, shift);
        this.twoDService.updateScene();
    }

    toggleVideoPlayNextFrame() {
        this.videoPlayControls.next = !this.videoPlayControls.next;
        this.videoPlayControls.previous = false;
    }

    toggleVideoPlayPreviousFrame() {
        this.videoPlayControls.previous = !this.videoPlayControls.previous;
        this.videoPlayControls.next = false;
    }

    togglePlayVideo(view: TwoDView, shift) {

        if (this.videoPlayControls.next || this.videoPlayControls.previous) {
            //If there is an existing interval, it is cleared using clearInterval(this.intervalId) before setting up a new interval.This is a common pattern to prevent multiple intervals from running simultaneously.
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            // drawNextFrame tells the system to run drawNextFrame every 300 milliseconds
            this.intervalId = setInterval(() => this.drawNextFrame(view, shift), 400);
        } else {
            clearInterval(this.intervalId);
        }
    }


    getSelectedItemsNames() {
        let names = [];

        for (let i = 0; i < this.markersService.markersData.selectedMarkersList.length; i++) {
            names.push(this.markersService.markersData.selectedMarkersList[i].name);
        }

        for (let i = 0; i < this.regionsService.regionsData.selectedRegions.length; i++) {
            names.push(this.regionsService.regionsData.selectedRegions[i].short_name);
        }

        return names;
    }

    getSelectedItemsColors() {
        let colors = [];

        for (let i = 0; i < this.markersService.markersData.selectedMarkersList.length; i++) {
            colors.push(this.markersService.markersData.selectedMarkersList[i].drawingInfo.color);
        }

        for (let i = 0; i < this.regionsService.regionsData.selectedRegions.length; i++) {
            colors.push(this.regionsService.regionsData.selectedRegions[i].drawingInfo.color);
        }

        return colors;
    }

    writeNamesOnScreenshot(canvas, names, colors) {
        let x = 10;
        let step = 15;
        let y = 20;
        let ySign = 1;

        if (TwoDViewVisualizationOptions.screenshotsOptions.location.bottom) {
            y = canvas.height - 20;
            ySign = -1;
        }

        for (let i = 0; i < names.length; i++) {
            let position = {x: x, y: y};
            drawString(names[i], position, colors[i], TwoDViewVisualizationOptions.labelsOptions.font, canvas);
            y += ySign * step;
        }

        this.twoDService.updateScene();

        return names;
    }

    onScreenshotClick(canvas, viewName: string) {
        let names = this.getSelectedItemsNames();
        let namesString = names.join('__')

        if (TwoDViewVisualizationOptions.screenshotsOptions.includeNames) {
            let colors = this.getSelectedItemsColors();
            this.writeNamesOnScreenshot(canvas, names, colors);
        }


        let dataURL = canvas.toDataURL("image/jpg", 1.0);
        if (viewName == "dorsal") {
            viewName = "horizontal"
        }
        let fileName = 'mapzebrain__' + viewName + '____' + namesString + '____' + Date.now().toString() + '.jpg'
        this.downloadImage(dataURL, fileName);
    }

    downloadImage(data, filename = 'untitled.jpg') {
        let a = document.createElement('a');
        a.href = data;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
    }

    onKeyDown(event) {
        if (this.layoutService.viewOptions.twoD) {
            // if (event.key === 'Alt') {
            if (event.key === 'z') {
                if (event.target.tagName.toUpperCase() !== 'INPUT' && event.target.tagName.toUpperCase() !== 'TEXTAREA') {
                    Zoom.update(true);
                }
            } else if (event.key === 'Shift') {
                this.shapeROIsService.isROIsDrawingMode = true;
            } else if (event.key === 'r') {
                this.shapeROIsService.isRectangularROIsDrawingMode = true;
            } else {
                if (event.key === 'ArrowLeft') {
                    SelectedPosition.coordinates[this.twoDService.activeView.getImageXAxis()] -= 1;
                    this.twoDService.updateScene();
                }
                if (event.key === 'ArrowRight') {
                    SelectedPosition.coordinates[this.twoDService.activeView.getImageXAxis()] += 1;
                    this.twoDService.updateScene();
                }

                if (event.key === 'ArrowUp') {
                    SelectedPosition.coordinates[this.twoDService.activeView.getImageYAxis()] -= this.twoDService.activeView.getYIncrementSign();
                    this.twoDService.updateScene();
                }
                if (event.key === 'ArrowDown') {
                    SelectedPosition.coordinates[this.twoDService.activeView.getImageYAxis()] += this.twoDService.activeView.getYIncrementSign();
                    this.twoDService.updateScene();
                }

                if (event.key === 'w') {
                    SelectedPosition.coordinates[this.twoDService.activeView.getImageZAxis()] += 1;
                    this.twoDService.updateScene();
                }
                if (event.key === 's') {
                    SelectedPosition.coordinates[this.twoDService.activeView.getImageZAxis()] -= 1;
                    this.twoDService.updateScene();
                }

            }
        }
    }

    onKeyUp(event) {
        if (this.layoutService.viewOptions.twoD) {
            // if (event.key === 'Alt') {
            if (event.key === 'z') {
                Zoom.update(false);
            } else if (event.key === 'Shift') {
                this.shapeROIsService.isROIsDrawingMode = false;
            } else if (event.key === 'r') {
                this.shapeROIsService.isRectangularROIsDrawingMode = false;
            }
        }
    }
}
